module.exports = __webpack_public_path__ + "img/07.cf377e5e.jpg";